import { Zap, Smartphone, ShieldCheck, Fingerprint, Smile } from "lucide-react";
import { Reveal, Chapter } from "./Reveal";

const BENEFITS = [
  { icon: Zap, title: "Instant Access", body: "Customers reach your review page with a simple tap — no searching, no typing." },
  { icon: Smartphone, title: "No App Required", body: "Works through standard NFC functionality on supported smartphones." },
  { icon: ShieldCheck, title: "Professionally Made", body: "A durable business tool — not a cheap promotional freebie." },
  { icon: Fingerprint, title: "Customized for Your Business", body: "Each order is programmed according to the information you provide." },
  { icon: Smile, title: "Simple for Customers", body: "No complicated instructions. Tap, and the page opens." },
];

export const Benefits = () => (
  <section className="bg-mist py-28 sm:py-36" data-testid="benefits-section">
    <div className="max-w-7xl mx-auto px-6">
      <Chapter number="09" label="Why Revora" />
      <Reveal>
        <h2 className="rvr-title font-display text-4xl md:text-5xl font-bold tracking-tight text-ink leading-[1.05] max-w-2xl">
          Effortless by design
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
        {BENEFITS.map((b, i) => (
          <Reveal key={b.title} delay={i * 0.08} className="h-full">
            <div
              data-testid={`benefit-${b.title.toLowerCase().replace(/\s+/g, "-")}`}
              className="group bg-white border border-black/10 rounded-sm p-8 h-full hover:border-ink transition-colors duration-300"
            >
              <div className="w-11 h-11 rounded-full bg-mist group-hover:bg-volt flex items-center justify-center transition-colors duration-300 mb-8">
                <b.icon className="w-5 h-5 text-ink group-hover:text-white transition-colors duration-300" />
              </div>
              <p className="font-display text-lg font-bold text-ink mb-2">{b.title}</p>
              <p className="text-sm text-black/55 leading-relaxed">{b.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
